import i18n from 'i18next';
import HttpApi from 'i18next-http-backend';

i18n.use(HttpApi).init({
  // we init with resources
  lng: 'en',
  fallbackLng: 'en',
  debug: false,

  // have a common namespace used around the full app
  ns: ['translations'],
  defaultNS: 'translations',

  keySeparator: false, // we use content as keys
  nsSeparator: false, // we use content as keys

  interpolation: {
    escapeValue: false, // not needed for react!!
    formatSeparator: ',',
  },

  react: {
    useSuspense: true,
  },
  backend: {
    loadPath: '/translations/{{lng}}/{{ns}}',
  },
});

export default i18n;
